module.exports = __webpack_public_path__ + "img/Pic_Text_XCFT.798294c0.png";